// extracted by mini-css-extract-plugin
export default {"chip":"RelationGroupChip_chip__OEWUg","chipSelected":"RelationGroupChip_chipSelected__NAxEP RelationGroupChip_chip__OEWUg"};